<template>
  <v-card class="mx-auto mt-2" outlined rounded>
    <v-list-tile>
      <v-list-tile-action>
        <v-icon color="red lighten-1">mdi-alert-circle</v-icon>
      </v-list-tile-action>

      <v-list-tile-content class="mt-2 mb-2">
        <v-list-tile-title>{{
          qualification.consumer_unit ||
          "Código Cliente: " + qualification.customer_number
        }}</v-list-tile-title>
        <v-list-tile-sub-title>{{
          getAddress(qualification.consumer_unit)
        }}</v-list-tile-sub-title>
        {{ disqualification.text }}
      </v-list-tile-content>

      <v-list-tile-action>
        <v-layout>
          <span class="font-weight-bold pl-2 pr-3"> Desqualificado </span>
          <v-tooltip bottom v-if="qualification.bill_path">
            <template v-slot:activator="{ on }">
              <v-btn
                color="tertiary"
                icon
                v-on="on"
                @click="download_pdf(qualification.bill_path)"
              >
                <v-icon color="white">receipt_long</v-icon>
              </v-btn>
            </template>
            <span>Baixar conta</span>
          </v-tooltip>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon color="grey lighten-1">receipt_long</v-icon>
              </v-btn>
            </template>
            <span>Conta indisponível</span>
          </v-tooltip>
        </v-layout>
      </v-list-tile-action>
    </v-list-tile>
  </v-card>
</template>
<script>
import { firestorage } from "@/firebase/firestorage";
export default {
  props: ["qualification", "installations_found"],
  computed: {
    disqualification() {
      if (this.qualification.status === "disqualified") {
        if (this.qualification.reason_disqualify === "low_consumption") {
          return {
            text:
              "Infelizmente não é possível contratar nossos serviços para a média de consumo de R$ " +
              (
                this.qualification.consumer_unit_detail.mediana *
                this.qualification.consumer_unit_detail.fare_amount
              )
                .toFixed(2)
                .replace(".", ","),
          };
        } else if (this.qualification.reason_disqualify === "not_holder") {
          return {
            text: "Os dados do cadastro não conferem com os dados do imóvel cadastrado na concessionária.",
          };
        } else if (this.qualification.reason_disqualify === "low_fare") {
          return {
            text: "Infelizmente não é possível contratar nossos serviços, pois sua tarifa atual já possui benefícios diferenciados ou é rural",
          };
        } else if (this.qualification.reason_disqualify === "low_savings") {
          return {
            text:
              "Infelizmente não é possível contratar nossos serviços para a média de consumo de R$ " +
              (
                this.qualification.consumer_unit_detail.mediana *
                this.qualification.consumer_unit_detail.fare_amount
              )
                .toFixed(2)
                .replace(".", ","),
          };
        } else if (this.qualification.reason_disqualify === "debits") {
          return {
            text: "Infelizmente não é possível contratar nossos serviços, pois identificamos restrições junto a concessionária",
          };
        } else if (this.qualification.reason_disqualify === "injected_energy") {
          return {
            text: "Infelizmente não é possível contratar nossos serviços, pois a unidade consumidora já possui injeção de energia",
          };
        } else {
          return {
            text: "Infelizmente não é possivel entregar energia limpa para seu imóvel!",
          };
        }
      } else {
        return {
          text: "Infelizmente não é possivel entregar energia limpa para seu imóvel!",
        };
      }
    },
  },
  methods: {
    getAddress(id) {
      if (this.installations_found) {
        const uc = this.installations_found.find((installation) => {
          return installation.installation_number === id;
        });
        if (uc) return uc.address;
      } else {
        return null;
      }
    },
    download_pdf(path) {
      const resumeRef = firestorage.ref(path);
      resumeRef
        .getDownloadURL()
        .then((url) => {
          window.open(
            url,
            "popup",
            "toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800",
          );
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
